import React, { useEffect, useState } from "react";

const FakeRunningBattle = ({ translations, language, winnAmount }) => {
  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);
  // console.log("addCaseSetting", addCaseSetting);
  // const [fakeBattles, setFakeBattles] = useState([]);
  const [fakeRunningBattles, setFakeRunningBattles] = useState([]);
  const indianNames = [
    "Aman",
    "Rahul",
    "Rohit",
    "Vikas",
    "Ankit",
    "Neha",
    "Riya",
    "Pooja",
    "Karan",
    "Yash",
  ];

  const attitudeNames = [
    "King",
    "Jaat",
    "Mahakal",
    "Don",
    "Badshah",
    "Legend",
    "Boss",
    "Royal",
  ];

  const emojis = [
    "🔥🔥",
    "😎😎😎😎",
    "👑",
    "🌹🌹🌹",
    "❤️",
    "💀💀",
    "👑⚡👑",
    "🚩",
    "🔥🦁🔥",
    "👑💎",
  ];

  const generateRandomString = () => {
    const chars = "abcdefghijklmnopqrstuvwxyz";

    const len = Math.floor(Math.random() * 4) + 5;

    let str = "";

    for (let i = 0; i < len; i++) {
      str += chars[Math.floor(Math.random() * chars.length)];
    }

    return str;
  };
  const getRandomName = () => {
    const rand = Math.random();

    // 60% random names
    if (rand < 0.6) {
      return generateRandomString();
    }

    // 20% indian names
    if (rand < 0.8) {
      return indianNames[Math.floor(Math.random() * indianNames.length)];
    }

    // 15% attitude names
    if (rand < 0.95) {
      return attitudeNames[Math.floor(Math.random() * attitudeNames.length)];
    }

    // 5% attitude + emoji
    return `${attitudeNames[Math.floor(Math.random() * attitudeNames.length)]}${
      emojis[Math.floor(Math.random() * emojis.length)]
    }`;
  };

  const generateUniqueNames = (count) => {
    const names = [];
    const used = new Set();

    while (names.length < count) {
      const name = getRandomName();

      if (!used.has(name)) {
        used.add(name);
        names.push(name);
      }
    }

    return names;
  };

  const shuffleArray = (array) => {
    const arr = [...array];

    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));

      [arr[i], arr[j]] = [arr[j], arr[i]];
    }

    return arr;
  };

  const getRandomAmount = () => {
    const rand = Math.random();

    // ₹50 - ₹1,500 = 20%
    if (rand < 0.2) {
      return Math.floor(Math.random() * 30) * 50 + 50;
    }

    // ₹1,600 - ₹3,000 = 20%
    if (rand < 0.4) {
      return Math.floor(Math.random() * 29) * 50 + 1600;
    }

    // ₹3,100 - ₹7,000 = 20%
    if (rand < 0.6) {
      return Math.floor(Math.random() * 79) * 50 + 3100;
    }

    // ₹7,000 - ₹15,000 = 20%
    if (rand < 0.8) {
      return Math.floor(Math.random() * 161) * 50 + 7000;
    }

    // ₹15,000 - ₹30,000 = 10%
    if (rand < 0.9) {
      return Math.floor(Math.random() * 301) * 50 + 15000;
    }

    // ₹30,000 - ₹50,000 = 10%
    return Math.floor(Math.random() * 401) * 50 + 30000;
  };
  const createFakeBattle = () => {
    let player1 = getRandomName();
    let player2 = getRandomName();

    while (player1 === player2) {
      player2 = getRandomName();
    }

    return {
      _id: `fake_${Date.now()}_${Math.random()}`,

      Status: "running",

      Game_Ammount: getRandomAmount(),

      Created_by: {
        _id: "bot1",
        Name: player1,
      },

      Accepetd_By: {
        _id: "bot2",
        Name: player2,
      },
    };
  };

  //   const ADMIN_FAKE_RUNNING_COUNT = 50; // backend se aayega
  const ADMIN_FAKE_RUNNING_COUNT = addCaseSetting?.runningBotNumber || 50;

  const getRandomBattleCount = (count) => {
    const min = Math.max(count - 15, 1);

    const max = count + 15;

    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  useEffect(() => {
    const battleCount = getRandomBattleCount(ADMIN_FAKE_RUNNING_COUNT);

    const names = generateUniqueNames(battleCount * 2);

    const battles = [];

    for (let i = 0; i < battleCount; i++) {
      battles.push({
        _id: `fake_${i}`,

        Status: "running",

        Game_Ammount: getRandomAmount(),

        Created_by: {
          _id: `bot_c_${i}`,
          Name: names[i * 2],
        },

        Accepetd_By: {
          _id: `bot_a_${i}`,
          Name: names[i * 2 + 1],
        },
      });
    }

    setFakeRunningBattles(battles);
  }, []);
  useEffect(() => {
    const replaceRandomBattle = () => {
      setFakeRunningBattles((prev) => {
        if (!prev.length) return prev;

        const updated = [...prev];

        const randomIndex = Math.floor(Math.random() * updated.length);

        updated[randomIndex] = createFakeBattle();

        return updated;
      });
    };

    const interval = setInterval(() => {
      replaceRandomBattle();
    }, 90000);
    // 90 seconds

    return () => clearInterval(interval);
  }, []);

  const truncateName = (name) => {
    return name?.length > 5 ? `${name.slice(0, 5)}...` : name;
  };

  return (
    <>
      {fakeRunningBattles.map((runnig) => (
        <div className="rb_gold_card" key={runnig._id}>
          <div className="rb_gold_top">
            <span className="rb_gold_heading">Playing For</span>

            <div className="rb_gold_name_main">
              <span className="rb_gold_name">
                {truncateName(runnig.Created_by.Name)}
              </span>

              <span className="rb_gold_and">&</span>

              <span className="rb_gold_name">
                {truncateName(runnig.Accepetd_By.Name)}
              </span>
            </div>
          </div>

          <div className="rb_gold_bottom">
            <div className="rb_gold_amount_box">
              <span className="rb_gold_label">
                {translations[language].entry}
              </span>

              <div className="rb_gold_amount">
                <img
                  src="/images/moneyrupee.png"
                  alt=""
                  width="18"
                  height="18"
                />

                <span>{runnig.Game_Ammount}</span>
              </div>
            </div>

            <div className="rb_gold_center">
              <img className="rb_gold_vs" src="../images/VS-image.png" alt="" />
            </div>

            <div className="rb_gold_amount_box">
              <span className="rb_gold_label">
                {translations[language].prize}
              </span>

              <div className="rb_gold_amount">
                <img
                  src="/images/moneyrupee.png"
                  alt=""
                  width="18"
                  height="18"
                />

                <span>
                  {runnig.Game_Ammount + winnAmount(runnig.Game_Ammount)}
                </span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default FakeRunningBattle;
